<template>
    <div class="guidePreview" ref="cmdlist">
        <pdf
        ref="pdf"
        class="guidePreview-pdf"
        :page="pageNum"
        :src="guideUrl"
        @num-pages="pageTotalNum=$event"
        ></pdf>
        <div class="guidePreview-button-group">
            <el-button class="guidePreview-button" type="primary" icon="el-icon-download" size="mini" @click="downloadFile"></el-button>
            <br>
            <el-button class="guidePreview-button" type="primary" icon="el-icon-arrow-up" size="mini" @click="prePage"></el-button>
            <br>
            <el-button class="guidePreview-button" type="primary" icon="el-icon-arrow-down" size="mini" @click="nextPage"></el-button>

        </div>
    </div>
</template>
<script>
import pdf from 'vue-pdf';
export default {
    name: 'guidePreview',
    components: { pdf },
    data() {
        return {
            guideUrl: '',
            pageNum: 1,
            pageTotalNum: 0
        };
    },
    methods: {
        backTop() {
            if (this.$refs.cmdlist) {
                this.$refs.cmdlist.scrollTop = 0;
            }
        },
        // 上一页
        prePage() {
            if (this.pageNum === 1) {
                this.$message.success('已经是第一页了！');
                return;
            }
            this.pageNum = this.pageNum - 1;
            this.backTop();
        },
        // 下一页
        nextPage() {
            if (this.pageNum === this.pageTotalNum) {
                this.$message.success('已经是最后一页了！');
                return;
            }
            this.pageNum = this.pageNum + 1;
            this.backTop();
        },
        downloadFile() {
            if (this.guideUrl) {
                window.location.href = this.guideUrl;
            }
        },
        setGuideUrl(guideUrl) {
            this.pageNum = 1;
            this.backTop();
            this.guideUrl = guideUrl;
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if (vm.$route.query.openNewTagUrl) {
                vm.setGuideUrl(vm.$route.query.openNewTagUrl);
            }
        });
    },
    watch: {
        '$route.query.openNewTagUrl': function () {
            if (this.$route.query.openNewTagUrl) {
                this.setGuideUrl(this.$route.query.openNewTagUrl);
            }
        }
    }
};
</script>
<style lang="less">
.guidePreview{
    background-color: #fff;
    overflow-y: auto;
    min-height: 100vh;
    .guidePreview-pdf{
        width: 70%;
        margin: auto;
    }
    .guidePreview-button-group{
        position: absolute;
        right: 20px;
        bottom: 20%;
    }
    .guidePreview-button{
        margin-top: 4px;
    }
}
</style>